import CanalCobroList from './CanalCobroList'
export {CanalCobroList}
export default CanalCobroList
